import Cookies from 'js-cookie';

if ($('.notification').length > 0) {
    let $notification = $('.notification');
    let $notificationButton = $('.notification__button');

    let notificationId = $notification.attr("data-id");
    let notificationCookie = "notification-bar-" + notificationId;
    let notificationLength = parseInt($notification.attr("data-length"));
    console.dir(notificationLength);

    if(Cookies.get(notificationCookie)) {
        $notification.addClass('-hidden');
    }

    function closeNotification(e) {
        e.preventDefault();
        $notification.addClass('-hidden');
        Cookies.set(notificationCookie, 'hidden', { expires: notificationLength });
    };

    $notificationButton.on('click', closeNotification);
};

